import React from 'react';
import { Link } from 'Components/molecules/Link';

export const getGalleryRelatedArticleLink = (galleryRelatedArticle) => {
  if (!galleryRelatedArticle || !galleryRelatedArticle.url || !galleryRelatedArticle.title) {
    return false;
  }
  return (
    <Link
      extraClassNames={{ '-is-gallery-related-article': true }}
      href={galleryRelatedArticle.url}
    >
      {`Go to: ${galleryRelatedArticle.title}`}
    </Link>
  );
};
